import { BNPLApi } from '@frontend/api-buy-now-pay-later';
import { useTranslation } from '@frontend/i18n';
import { paymentsQueryKeys, paymentsSentry } from '@frontend/payments-hooks';
import { useScopedQuery } from '@frontend/scope';
import { useAlert } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../collect-payment-multi.context';

const errMsg = 'Error creating the BNPL link';

export const useBnplLink = ({
  personPhone,
  isBnplRequest = false,
}: {
  personPhone: string;
  isBnplRequest: boolean;
}) => {
  const { t } = useTranslation('payments');
  const alerts = useAlert();
  const { invoice } = useCollectPaymentMultiContext();

  const locationId = invoice?.locationId;
  const amount = invoice?.billedAmount;

  const {
    data: bnplTtpLink,
    error,
    isLoading: bnplLinkLoading,
    refetch: refetchBnplTtpLink,
  } = useScopedQuery({
    queryKey: [locationId, paymentsQueryKeys.bnplTtpLink, amount, personPhone],
    queryFn: () => BNPLApi.getBnplTtpLink(locationId!, amount!, personPhone),
    enabled: !!isBnplRequest && !!invoice?.id && !!personPhone,
    onError: (error) => {
      alerts.error(t("Couldn't get the Pay Over Time link"));
      if (error instanceof Error) {
        paymentsSentry.error('Failed to create BNPL link', 'BNPLLink', error.message);
      }
    },
  });
  return {
    bnplTtpLink,
    bnplLinkError: error ? errMsg : undefined,
    bnplLinkLoading,
    refetchBnplTtpLink,
  };
};
